import { AbstractControl, AsyncValidatorFn } from "@angular/forms";
import { map } from "rxjs";
import { IBaseGetByComanyRequest, IBaseSearchRequest } from "src/app/core/models/base";
import { DeviceService } from "src/app/devices/services/device.service";

export function DeviceLocationValidator(deviceService: DeviceService, id: string): AsyncValidatorFn {
    return  (control: AbstractControl) => {
        const request : IBaseGetByComanyRequest= {
            pageNumber:0,
            pageSize: 999999,
            companyId: id,
            advancedFilter:{
                logic: "and",
                filters: [
                    {
                        field: 'name',
                        operator: 'eq',
                        value: control.value
                    }
                ]
            }
        }

        return deviceService.getDeviceLocationsByCompany(request)
        .pipe(
            map(response => {
                const deviceLocations = response.data;

                return deviceLocations.length != 0 ? {deviceLocationExists: true} : null;
            })
        )
    }
}
